'use client';

import dynamic from 'next/dynamic';
import CardLocation from '@alltrails/amplitude/enums/CardLocation';
import MapLocation from '@alltrails/amplitude/enums/MapLocation';
import TrailCardLocation from '@alltrails/amplitude/enums/TrailCardLocation';
import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import type { TrailSearchResult } from '@alltrails/types/AlgoliaResults';
import MapProvider from '../MapProvider/MapProvider';
import styles from './TrailListMap.module.scss';

export const LoadingMap = () => (
  <div className={styles.mapContainer}>
    <ShimmerContainer className={styles.shimmerContainer}>
      <div />
    </ShimmerContainer>
  </div>
);

const TrailListMap = dynamic(() => import('./TrailListMap'), {
  ssr: false,
  loading: LoadingMap
});

type DynamicTrailListMapProps = {
  isLoading?: boolean;
  trailSearchResults: TrailSearchResult[];
  zoomToTrails?: TrailSearchResult[];
  easeOnRecenter?: boolean;
  recenterDuration?: number;
  fadeThresholdMiles?: number;
  exploreLink?: string;
  mapLocation?: MapLocation | string; // Accept string for legacy PageStrings support
  cardLocation?: TrailCardLocation;
  detailedCardLocation?: CardLocation;
  onExpandMap?: () => void;
  isExpanded?: boolean;
};

const DynamicTrailListMap = ({
  isLoading,
  trailSearchResults,
  zoomToTrails,
  easeOnRecenter,
  recenterDuration,
  fadeThresholdMiles,
  exploreLink,
  mapLocation,
  cardLocation,
  detailedCardLocation,
  onExpandMap,
  isExpanded
}: DynamicTrailListMapProps) => {
  if (isLoading) {
    return <LoadingMap />;
  }

  return (
    <MapProvider>
      <TrailListMap
        trailSearchResults={trailSearchResults}
        zoomToTrails={zoomToTrails}
        easeOnRecenter={easeOnRecenter}
        recenterDuration={recenterDuration}
        fadeThresholdMiles={fadeThresholdMiles}
        exploreLink={exploreLink}
        mapLocation={mapLocation}
        cardLocation={cardLocation}
        detailedCardLocation={detailedCardLocation}
        onExpandMap={onExpandMap}
        isExpanded={isExpanded}
      />
    </MapProvider>
  );
};

export default DynamicTrailListMap;
